module.exports = __webpack_public_path__ + "static/media/education-bg.cf8a2d5c.png";